import React from 'react';
import { ClickableElement } from '@cko/primitives';
import styled from 'styled-components';
import { baseSidebarElement } from './baseSidebarElement';
const StyledClickableElement = styled(ClickableElement) `
  ${baseSidebarElement}

  display: flex;
  align-items: center;
`;
// @deprecated Sidebar has been removed and Sidebar links will follow soon. See https://checkout.atlassian.net/browse/DASH-2788
export const SidebarButton = ({ label, icons, onClick }) => (React.createElement(StyledClickableElement, { onClick: onClick },
    React.createElement("span", { className: "icon iconDefault" },
        React.createElement(icons.default),
        " "),
    React.createElement("span", { className: "icon iconSelected" },
        React.createElement(icons.selected),
        " "),
    label));
